import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PageHeader = ({ eyebrow, h1, intro, image, imageAlt, crumbs, children }) => (
  <section className="relative overflow-hidden bg-emerald-950 text-white" data-testid="page-header">
    {image && (
      <img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover opacity-45" width="1600" height="900" fetchPriority="high" />
    )}
    <div className="absolute inset-0" style={{ background: "linear-gradient(110deg, rgba(1,27,21,0.92) 0%, rgba(2,44,34,0.78) 45%, rgba(6,78,59,0.35) 100%)" }} />
    <div className="container-lux relative py-16 sm:py-20 lg:py-28">
      <nav aria-label="breadcrumb" className="mb-8" data-testid="breadcrumbs">
        <ol className="flex flex-wrap items-center gap-1.5 text-xs text-white/65">
          {crumbs.map((c, i) => (
            <li key={c.to} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight className="h-3 w-3 text-gold" />}
              {i < crumbs.length - 1 ? (
                <Link to={c.to} className="transition-colors hover:text-gold-light">{c.label}</Link>
              ) : (
                <span className="text-white/90" aria-current="page">{c.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <div className="fade-up max-w-3xl">
        {eyebrow && <span className="eyebrow !text-gold-light">{eyebrow}</span>}
        <h1 className="mt-4 text-4xl font-bold leading-[1.1] sm:text-5xl lg:text-6xl" data-testid="page-h1">{h1}</h1>
        {intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/80 md:text-lg">{intro}</p>}
        {children}
      </div>
    </div>
    <div className="gold-rule" />
  </section>
);
